import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
function NikoFacilityOrderNewFlowInventoryCalculationVerificationModalTemplate({ nikoFacilityOrderNewFlowInventoryCalculationVerificationModalStore }) {
    const {
        facilityInventoryCalculationItem
    } = nikoFacilityOrderNewFlowInventoryCalculationVerificationModalStore;

    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title'>Calculation Verification</h3>
            </div>
            <div className="modal__body">
                <div className="u-mar--bottom--sml">
                    <h3 className='modal__header__title u-mar--bottom--sml'>
                        {facilityInventoryCalculationItem.itemId} {facilityInventoryCalculationItem.product}
                    </h3>
                </div>
                <table className="table--preview">
                    <thead>
                        <tr>
                            <th className="type--left">SALES ORDER QTY NEEDED</th>
                            <th className="type--left">EMERGENCY STOCK NEEDED</th>
                            <th className="type--left">TOTAL STOCK NEEDED</th>
                            <th className="type--left">INVENTORY COUNT QTY{facilityInventoryCalculationItem.isOtherBottleUsedForCalculation && <span style={{ fontWeight: 'bold', fontSize: '1.5em', color: 'red' }}>{"*"}</span>}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr key={facilityInventoryCalculationItem.id}>
                            <td>{facilityInventoryCalculationItem.salesOrderQty}</td>
                            <td>{facilityInventoryCalculationItem.quantity}</td>
                            <td>{facilityInventoryCalculationItem.stockNeededQuantity}</td>
                            <td>{facilityInventoryCalculationItem.additionalQuantity ? facilityInventoryCalculationItem.additionalQuantity : facilityInventoryCalculationItem.inventoryCountQty}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section >
    )
}

NikoFacilityOrderNewFlowInventoryCalculationVerificationModalTemplate.propTypes = {
    nikoFacilityOrderNewFlowInventoryCalculationVerificationModalStore: PropTypes.object
};

export default defaultTemplate(NikoFacilityOrderNewFlowInventoryCalculationVerificationModalTemplate);
